import request from '@/api' // 引入配置好的axios实例


export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    
    data: data
  })
}

export function logout(data) {
  return request({
    url: '/logout',
    method: 'post',
    
    data: data
  })
}

// 个人中心 
export function getTenantListByUserName() {
  return request({
    url: `/system/user/profile`,
    method: 'get',
  })
}
// 公司名称
export function getTenantName() {
  return request({
    url: `/system/user/getTenantListByUserName`,
    method: 'get',
  })
}

export function getdictTypeList(type) {
  return request({
    url: `/system/dict/data/list?pageNum=1&pageSize=999&dictType=${type}`,
    method: 'get',
  })
}
// /system/user/profile/updatePwd  修改密码
export function updatePwd(data) {
  return request({
    url: `/system/user/profile/updatePwd`,
    method: 'put',
    data: data,
  })
}
//  获取权限列表
export function getAppRounters() {
  return request({
    url: `/getAppRounters`,
    method: 'get',
  })
}
